import React from 'react';
import './style.scss';
import { FormError } from '../formErrorScroll';

export type CheckBoxItem = {
  label: string;
  value: number;
  checked: boolean;
};
type CheckBoxGroupProps = {
  items: CheckBoxItem[];
  setItems?: (items: CheckBoxItem[]) => void;
  exclusiveItem?: string;
  error?: string;
};

export const CheckBoxGroup = ({ items, setItems, exclusiveItem, error }: CheckBoxGroupProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newItems = items.map((item) => {
      const newItem = { ...item };
      if (newItem.label === e.target.value) {
        newItem.checked = !newItem.checked;
      }
      return newItem;
    });

    if (exclusiveItem) {
      const exclusiveOn = e.target.value === exclusiveItem && newItems.find((x) => x.label === exclusiveItem)?.checked;
      newItems
        .filter((item) => (exclusiveOn ? item.label !== exclusiveItem : item.label === exclusiveItem))
        .forEach((item) => {
          item.checked = false;
        });
    }
    setItems && setItems(newItems);
  };

  return (
    <div className="choicesWrapper">
      <div className="choicesWrapper_choices">
        {items?.map((item) => {
          return (
            <div className="establishChoices" key={item.label}>
              <input id={item.label} type="checkbox" value={item.label} checked={item.checked} onChange={onChange} />
              <label htmlFor={item.label}>{item.label}</label>
            </div>
          );
        })}
      </div>
      <FormError className="choicesWrapper_error" error={error} />
    </div>
  );
};
